import React, { useEffect, useState } from 'react';
import axios from 'axios';

import LandingRenderer from '../components/landing/LandingRenderer';
import { DEFAULT_LANDING_CONTENT, normalizeLandingContent } from '../components/landing/landingContent';
import { API } from '../context/AuthContext';

const LandingPage = () => {
  const [content, setContent] = useState(() => normalizeLandingContent(DEFAULT_LANDING_CONTENT));

  useEffect(() => {
    let active = true;

    axios.get(`${API}/landing-content`)
      .then(({ data }) => {
        if (active) setContent(normalizeLandingContent(data));
      })
      .catch(() => {
        // La landing pública siempre conserva el contenido visual predeterminado.
      });

    return () => {
      active = false;
    };
  }, []);

  return (
    <LandingRenderer
      content={content}
      mode="responsive"
      editable={false}
    />
  );
};

export default LandingPage;
